import React from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#fff5f7",
        padding: "40px 0 20px",
        borderTop: "1px solid #f0dce3",
      }}
    >
      <Container>
        {/* CONTACT US SECTION */}
        {/* CONTACT US SECTION */}
<Row className="mb-4">
  <Col className="text-center">
    <h5 style={{ fontWeight: 700, marginBottom: "24px" }}>
      Contact Us
    </h5>
  </Col>
</Row>

<Row className="g-4 justify-content-center">
  {/* Phone */}
  <Col md={4}>
    <div
      style={{
        background: "#ffffff",
        borderRadius: "16px",
        padding: "24px",
        textAlign: "center",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-6px)";
        e.currentTarget.style.boxShadow =
          "0 12px 28px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 6px 18px rgba(0,0,0,0.08)";
      }}
    >
      <div style={{ fontSize: "28px", marginBottom: "10px" }}>📞</div>
      <h6 style={{ fontWeight: 700 }}>Phone</h6>
      <p style={{ margin: 0, color: "#555" }}>
        +1 (832) 274-1573
      </p>
    </div>
  </Col>

  {/* Email */}
  <Col md={4}>
    <div
      style={{
        background: "#ffffff",
        borderRadius: "16px",
        padding: "24px",
        textAlign: "center",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-6px)";
        e.currentTarget.style.boxShadow =
          "0 12px 28px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 6px 18px rgba(0,0,0,0.08)";
      }}
    >
      <div style={{ fontSize: "28px", marginBottom: "10px" }}>✉️</div>
      <h6 style={{ fontWeight: 700 }}>Email</h6>
      <p style={{ margin: 0, color: "#555" }}>
        contact@apexremodeling.com
      </p>
    </div>
  </Col>

  {/* Address */}
  <Col md={4}>
    <div
      style={{
        background: "#ffffff",
        borderRadius: "16px",
        padding: "24px",
        textAlign: "center",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-6px)";
        e.currentTarget.style.boxShadow =
          "0 12px 28px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 6px 18px rgba(0,0,0,0.08)";
      }}
    >
      <div style={{ fontSize: "28px", marginBottom: "10px" }}>📍</div>
      <h6 style={{ fontWeight: 700 }}>Address</h6>
      <a
  href="https://www.google.com/maps/place/Apex+Carpet+%26+Tile/@29.840917,-95.646096,17z/data=!4m16!1m9!3m8!1s0x8640d9f7e147a8f5:0xc8bd44d032947632!2sApex+Carpet+%26+Tile!8m2!3d29.840917!4d-95.646096!9m1!1b1!16s%2Fg%2F1tlvpxw7!3m5!1s0x8640d9f7e147a8f5:0xc8bd44d032947632!8m2!3d29.840917!4d-95.646096!16s%2Fg%2F1tlvpxw7!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    margin: 0,
    color: "#555",
    textDecoration: "none",
  }}
>
  4551 Hwy 6 N, Houston, TX 77084, US
</a>

    </div>
  </Col>
</Row>

        <hr style={{ opacity: 0.2, margin: "30px 0" }} />

        {/* COPYRIGHT (UNCHANGED) */}
        <Row>
          <Col className="text-center">
            <small style={{ color: "#777" }}>
              © 2026 Apex Carpet, Tile & Remodeling. All rights reserved.
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
